<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import IconButton from '../IconButton.vue';
    import { ArrowDownIcon, ArrowUpIcon } from '@lucide/vue';

    defineProps<{
        name: string;
        sortable?: boolean;
        activeSort?: 'asc' | 'desc';
    }>();

    defineEmits<{
        (e: 'sort', direction: 'asc' | 'desc'): void;
    }>();
</script>

<template>
    <div class="flex py-6 items-center gap-1 text-overline-sm">
        <span>{{ name }}</span>

        <template v-if="sortable">
            <div class="-m-1">
                <IconButton
                    size="size-4"
                    area-size="size-6"
                    :aria-label="__('sort-ascending-label')"
                    :disabled="activeSort === 'asc'"
                    @click="$emit('sort', 'asc')"
                >
                    <ArrowUpIcon />
                </IconButton>
            </div>
            <div class="-m-1">
                <IconButton
                    size="size-4"
                    area-size="size-6"
                    :aria-label="__('sort-descending-label')"
                    :disabled="activeSort === 'desc'"
                    @click="$emit('sort', 'desc')"
                >
                    <ArrowDownIcon />
                </IconButton>
            </div>
        </template>
    </div>
</template>
